export default function debounce(
  callback: (...args: unknown[]) => void,
  wait = 500
) {
  let timeout: NodeJS.Timeout | undefined;
  return (...args: unknown[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback.apply(this, args), wait);
  };
}
